import { render, staticRenderFns } from "./OkrPremisesBlock.vue?vue&type=template&id=0520c18f&scoped=true"
import script from "./OkrPremisesBlock.vue?vue&type=script&lang=js"
export * from "./OkrPremisesBlock.vue?vue&type=script&lang=js"
import style0 from "./OkrPremisesBlock.vue?vue&type=style&index=0&id=0520c18f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0520c18f",
  null
  
)

export default component.exports